// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const FactoryFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="FactoryFilledIcon" ref={forwardedRef} {...props}>
      <path d="M13.996 2.25c-.64 0-1.246-.174-1.67-.44C11.9 1.54 11.75 1.247 11.75 1h-1.5c0 .937.587 1.644 1.277 2.078.693.438 1.585.672 2.469.672.447 0 .711.183.905.518C15.124 4.653 15.25 5.251 15.25 6h1.5c0-.871-.14-1.773-.55-2.483-.44-.76-1.178-1.267-2.204-1.267" />
      <path d="M9.205 3.992C9.67 4.212 10.272 4.25 10.75 4.25c.677 0 1.45.25 2.064.679S14 6.06 14 7h-1.5c0-.278-.167-.577-.546-.842-.38-.266-.857-.408-1.204-.408-.498 0-1.396-.027-2.187-.402a2.67 2.67 0 0 1-1.107-.939C7.158 3.96 7 3.404 7 2.75h1.5c0 .406.095.663.207.833a1.2 1.2 0 0 0 .498.41" />
      <path d="M16.75 7h-1.5L14 11 8 8v3L2 8v10h16v-7zM7 12.5V14H4v-1.5zm2 0h3V14H9z" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const FactoryFilledIcon = /* @__PURE__ */ Object.assign(
  FactoryFilledIconComponent,
  { displayName: 'FactoryFilledIcon' },
);
